import moment from 'moment'

moment.updateLocale('en', {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
})
moment.updateLocale('de', {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
})

export const DATEPICKER_LOCALE_DATA = {
  de: {
    applyLabel: 'Übernehmen',
    cancelLabel: 'Abbrechen',
    daysOfWeek: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    firstDay: 1,
    format: 'dd.mm.yyyy',
    monthNames: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
  },
  en: {
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    firstDay: 1,
    format: 'dd.mm.yyyy',
    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
}

const ranges = {
  'This Week': [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
  'Last Week': [
    moment().subtract(1, 'weeks').startOf('week').toDate(),
    moment().subtract(1, 'weeks').endOf('week').toDate(),
  ],
  'This month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
  'Last month': [
    moment().subtract(1, 'months').startOf('month').toDate(),
    moment().subtract(1, 'months').endOf('month').toDate(),
  ],
  'Last 3 months': [
    moment().subtract(3, 'months').startOf('month').toDate(),
    moment().subtract(1, 'months').endOf('month').toDate(),
  ],
  'Last 6 months': [
    moment().subtract(6, 'months').startOf('month').toDate(),
    moment().subtract(1, 'months').endOf('month').toDate(),
  ],
}

export const DATEPICKER_RANGES = {
  en: ranges,
  de: {
    'Diese Woche': ranges['This Week'],
    'Letzte Woche': ranges['Last Week'],
    'Dieser Monat': ranges['This month'],
    'Letzter Monat': ranges['Last month'],
    'Letzte 3 Monate': ranges['Last 3 months'],
    'Letzte 6 Monate': ranges['Last 6 months'],
  },
}
